import React from 'react';
import PropTypes from 'prop-types';
import { DialogActions, Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useFormikContext } from 'formik';
import { LoadingButton } from '~/modules/common/components';
import useSetResourceAllocationPeriodError from './hooks/useSetResourceAllocationPeriodError';

const SetResourceAllocationDialogFooter = ({
  isSmartFitOpen,
  isSaving,
  onClose
}) => {
  const { handleSubmit } = useFormikContext();
  const { allocationError } = useSetResourceAllocationPeriodError();

  const isLoading = isSmartFitOpen || isSaving;

  return (
    <DialogActions>
      <Button
        data-qe-id="SetResourceAllocationDialog_CancelButton"
        disabled={isLoading}
        onClick={onClose}
        variant="contained"
      >
        <FormattedMessage id="setResourceAllocationDialog.cancel" />
      </Button>
      <LoadingButton
        color="primary"
        data-qe-id="SetResourceAllocationDialog_SubmitButton"
        disabled={isLoading || Boolean(allocationError)}
        isLoading={isLoading}
        onClick={handleSubmit}
        variant="contained"
      >
        <FormattedMessage id="setResourceAllocationDialog.setResourceAllocation" />
      </LoadingButton>
    </DialogActions>
  );
};

SetResourceAllocationDialogFooter.propTypes = {
  isSmartFitOpen: PropTypes.bool,
  isSaving: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

export default SetResourceAllocationDialogFooter;
